<template>
  <div id="analyze">
  <div class="container mt-3">
  <div class="row">
    <div class="col-12">
      <b-button variant="outline-secondary" class="title-font float-right" size="sm"
        @click="resetConf(true);">pro</b-button>
    </div>
  </div>
  <div class="row">
      <div class="col-12">
        <counter :info="info"></counter>
      </div>
    </div>
    <div class="container mw-600 mt-4">
      <div class="row">
        <div class="col-5 pa-2">
          <b-button :disabled="!(info.nextSv !== 2 && isGameProg)"
            class="btn-dblue" @click="addPoint({'point':1, 'label':1})">
            サーブ
            </b-button>
        </div>
        <div class="col-5 pa-2">
          <b-button :disabled="!(info.nextSv !== 1 && isGameProg)"
            class="btn-dgreen" @click="addPoint({'point':0, 'label':1})">
            サーブ
            </b-button>
        </div>
        <div class="col-2 pa-2">
          <b-button :disabled="!(info.nextSv !== 0)" variant="outline-secondary"
            class="btn-option" @click="delPoint()">
            <font-awesome-icon icon="backspace" />
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-5 pa-2">
          <b-button :disabled="!(info.nextSv !== 1 && isGameProg)"
            class="btn-dblue" @click="addPoint({'point':1, 'label':2})">
            レシーブ
          </b-button>
        </div>
        <div class="col-5 pa-2">
          <b-button :disabled="!(info.nextSv !== 2 && isGameProg)"
            class="btn-dgreen" @click="addPoint({'point':0, 'label':2})">
            レシーブ
          </b-button>
        </div>
        <div class="col-2 pa-2">
          <b-button variant="outline-secondary" class="btn-option" v-b-modal.modal-1>
            <font-awesome-icon icon="wrench"/>
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-5 pa-2">
          <b-button :disabled="!(info.nextSv !== 2 && isGameProg)"
            class="btn-dblue" @click="addPoint({'point':1, 'label':3})">
            3球目
          </b-button>
        </div>
        <div class="col-5 pa-2">
          <b-button :disabled="!(info.nextSv !== 1 && isGameProg)"
            class="btn-dgreen" @click="addPoint({'point':0, 'label':3})">
            3球目
          </b-button>
        </div>
        <div class="col-2 pa-2">
          <b-button variant="outline-secondary" class="btn-option" v-b-modal.modal-3>
            <font-awesome-icon icon="link"/>
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-5 pa-2">
          <b-button :disabled="!(info.nextSv !== 1 && isGameProg)"
            class="btn-dblue" @click="addPoint({'point':1, 'label':4})">
            4球目
          </b-button>
        </div>
        <div class="col-5 pa-2">
          <b-button :disabled="!(info.nextSv !== 2 && isGameProg)"
             class="btn-dgreen" @click="addPoint({'point':0, 'label':4})">
             4球目
            </b-button>
        </div>
        <div class="col-2 pa-2">
          <b-button variant="outline-secondary" class="btn-option" v-b-modal.modal-2>
            <font-awesome-icon icon="plus"/>
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-5 pa-2">
          <b-button :disabled="!(info.nextSv !== 2 && isGameProg)" class="btn-dblue"
            @click="addPoint({'point':1, 'label':5})">
            5球目
          </b-button>
        </div>
        <div class="col-5 pa-2">
          <b-button :disabled="!(info.nextSv !== 1 && isGameProg)" class="btn-dgreen"
            @click="addPoint({'point':0, 'label':5})">
            5球目
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-5 pa-2">
          <b-form-input id="manual-input-1" v-model.number="manualInput1"
            placeholder="ラリー本数を入力" type="number">
            {{ manualInput1 }}
          </b-form-input>
        </div>
        <div class="col-5 pa-2">
          <b-form-input id="manual-input-2" v-model.number="manualInput2"
            placeholder="0または6以上" type="number">
            {{ manualInput2 }}
          </b-form-input>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-5 pa-2">
          <b-button :disabled="!isManualInput1" class="btn-dblue"
            @click="addPoint({'point':1, 'label':manualInput1})">
            入力
          </b-button>
        </div>
        <div class="col-5 pa-2">
          <b-button :disabled="!isManualInput2" class="btn-dgreen"
            @click="addPoint({'point':0, 'label':manualInput2})">
            入力
          </b-button>
        </div>
        <div class="col-2 pa-2">
          <b-button variant="outline-secondary" class="btn-option" @click="resetConf(false)">
            <strong>C</strong>
          </b-button></div>
      </div>
      <!-- ユーザーが作成したボタンを表示 -->
      <div class="row" v-for="(label, idx) in game.manualLabels" :key="idx">
        <!-- points配列と長さが等しいなら未入力状態 -->
        <div class="col-5 pa-2" v-if="game.points.length === label.value.length && isGameProg">
          <b-button class="btn-dblue" @click="addManualArray({name:label.name, p:1})">
            {{ label.name }}
          </b-button>
        </div>
        <!-- label.valueの一番後ろが1なら戻すボタンを表示 -->
        <div class="col-5 pa-2" v-else-if="label.value[label.value.length-1] === 1 && isGameProg">
          <b-button class="btn-dblue" @click="popManualArray({name:label.name, p:1})">
            <font-awesome-icon icon="backspace" />
          </b-button>
        </div>
        <!-- その他の場合非活性にする -->
        <div class="col-5 pa-2" v-else>
          <b-button class="btn-dblue" disabled>{{ label.name }}</b-button>
        </div>
        <!-- points配列と長さが等しいなら未入力状態 -->
        <div class="col-5 pa-2" v-if="game.points.length === label.value.length && isGameProg">
          <b-button class="btn-dgreen" @click="addManualArray({name:label.name, p:2})">
            {{ label.name }}
          </b-button>
        </div>
        <!-- label.valueの一番後ろが2なら戻すボタンを表示 -->
        <div class="col-5 pa-2" v-else-if="label.value[label.value.length-1] === 2 && isGameProg">
          <b-button class="btn-dgreen" @click="popManualArray({name:label.name})">
            <font-awesome-icon icon="backspace" />
          </b-button>
        </div>
        <!-- その他の場合非活性にする -->
        <div class="col-5 pa-2" v-else>
          <b-button class="btn-dgreen" disabled>{{ label.name }}</b-button>
        </div>
      </div>
      <div v-if="game.gameInfo.memoFlg == 1" class="mb-4 mt-4">
        <b-form-textarea id="textarea" v-model="game.gameInfo.memo"
          placeholder="メモ" rows="5" max-rows="1000" />
      </div>
      <div class="mt-4">
        <div v-if="!user.signIn" class="text-muted">ログイン後データを保存できます</div>
        <b-button variant="primary" :disabled="!user.signIn"
          class="btn-block btn-lg" @click="submitData(true)" v-if="user.signIn && app.docId">
          更新する
          </b-button>
        <b-button variant="primary" :disabled="!user.signIn || submittingFlg"
          class="btn-block btn-lg" @click="submitData(true)" v-else>
          保存する
        </b-button>
      </div>
    </div>
    <!--モーダルの設定-->
    <b-modal id="modal-1" centered title="設定" hide-footer>
      <label>試合名</label>
      <b-form-input v-model="game.gameInfo.matchName">{{ game.gameInfo.matchName }}</b-form-input>
      <label class="mt-3">選手名</label>
      <b-form-input v-model="game.gameInfo.player1Name">
        {{ game.gameInfo.player1Name }}
      </b-form-input>
      <b-form-input v-model="game.gameInfo.player2Name">
        {{ game.gameInfo.player2Name }}
      </b-form-input>
      <label class="mt-3">ゲーム数</label>
      <b-form-select v-model="game.gameInfo.matchCnt" :options="options"></b-form-select>
      <label class="mt-3">メモの保存</label>
      <b-form-checkbox v-model="game.gameInfo.memoFlg">保存する</b-form-checkbox>
      <div class="mt-3">
        <b-button variant="outline-secondary" class="btn-sm"
          @click="outputData()" v-if="user.signIn && this.app.docId">
          <font-awesome-icon icon="file-download" /> CSVダウンロード
        </b-button>
        <b-button variant="danger" class="btn-sm float-right"
          @click="deleteData()" v-if="user.signIn && this.app.docId">
          <font-awesome-icon icon="trash-alt" /> 削除する
        </b-button>
      </div>
    </b-modal>
    <!--モーダルの設定-->
    <b-modal id="modal-3" centered title="共有設定" hide-footer>
      <div class="mt-3" @click="publicShareFlgOnClick()">
        <b-form-checkbox v-model="game.gameInfo.linkShareFlg">
          リンクを知っている人に公開する
        </b-form-checkbox>
      </div>
      <div class="mt-3" @click="linkShareFlgOnClick()">
        <b-form-checkbox v-model="game.gameInfo.publicShareFlg">
          みんなの分析で公開する
        </b-form-checkbox>
      </div>
      <div class="mt-3">
        <b-form-checkbox v-model="game.gameInfo.isRealTime"
          :disabled="!(user.signIn && this.app.docId)">
          ライブ配信を有効にする
        </b-form-checkbox>
      </div>
    </b-modal>
    <b-modal id="modal-2" centered title="パターンの追加" hide-footer>
      <div v-for="(label, idx) in game.manualLabels" :key="idx">
        <div class="row mt-3">
          <label class="col-9">{{ label.name }}</label>
          <div class="col-2">
            <b-button variant="danger" @click="delManualLabel({name: label.name});manualName='';">
              <font-awesome-icon icon="minus"/>
            </b-button>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-9"><b-form-input v-model="manualName"></b-form-input></div>
        <div class="col-2" v-if="!manualName || manualName in game.manualLabels">
          <b-button disabled variant="primary"><font-awesome-icon icon="plus"/></b-button>
        </div>
        <div class="col-2" v-else>
          <b-button variant="primary"
            @click="addManualLabel({name: manualName, value:[]});manualName='';">
            <font-awesome-icon icon="plus"/>
          </b-button>
        </div>
      </div>
    </b-modal>
    <graph :game="game" />
    <div class="row mt-5">
      <div class="col-12 text-center">
        <b-button variant="outline-secondary" class="btn" @click="$router.push('/detail_data');">
          詳細データ
        </b-button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/firestore';
import counter from '@/components/molecules/Counter';
import Graph from '@/components/organisms/Graph';
import func from '@/lib/func';
import makeCsv from '@/lib/makeCsv';

export default {
  name: 'analyze-normal',
  components: {
    counter,
    Graph,
  },
  data() {
    return {
      manualInput1: '',
      manualInput2: '',
      options: [
        { value: 1, text: '1ゲーム' },
        { value: 2, text: '3ゲーム（2ゲーム先取）' },
        { value: 3, text: '5ゲーム（3ゲーム先取）' },
        { value: 4, text: '7ゲーム（4ゲーム先取）' },
      ],
      manualName: '',
      intervalId: undefined,
      submittingFlg: false,
    };
  },
  mounted() {
    this.intervalId = setInterval(() => {
      if (this.game.gameInfo.isRealTime) {
        this.submitData(false);
      }
    }, 15000);
  },
  destroyed() {
    clearInterval(this.intervalId);
  },
  computed: {
    info() {
      let info = { p1: 0, p2: 0, s1: 0, s2: 0, nextSv: 0 };
      for (let i = 0; i < this.game.points.length; i++) {
        info = func.nextPoint(info, this.game.points[i]);
      }
      if ((info.p1 + info.p2 + info.s1 + info.s2) <= 0) {
        this.addGameInfo({ key: 'firstGameServer', value: 0 });
      } else {
        const label = this.game.labels[this.game.labels.length - 1];
        const point = this.game.points[this.game.points.length - 1];
        if (info.p1 + info.p2 > 0) {
          this.addGameInfo({ key: 'firstGameServer', value: func.getFristGameServer(info, point, label) });
        }
      }
      if (this.game.gameInfo.firstGameServer !== 0) {
        info.nextSv = func.getNextServer(info, this.game.gameInfo.firstGameServer);
      }
      return info;
    },
    isGameProg() {
      // true: ゲーム途中, false: ゲーム終了
      if (this.info.s1 === this.game.gameInfo.matchCnt
        || this.info.s2 === this.game.gameInfo.matchCnt) {
        return false;
      }
      return true;
    },
    isManualInput1() {
      if ((this.manualInput1 > 5 || this.manualInput1 === 0) && this.manualInput1 !== '') {
        if (this.info.nextSv % 2 === this.manualInput1 % 2 && this.isGameProg) {
          return true;
        } else if (this.info.nextSv === 0) {
          return true;
        }
      }
      return false;
    },
    isManualInput2() {
      if ((this.manualInput2 > 5 || this.manualInput2 === 0) && this.manualInput2 !== '') {
        if (this.info.nextSv % 2 !== this.manualInput2 % 2 && this.isGameProg) {
          return true;
        } else if (this.info.nextSv === 0) {
          return true;
        }
      }
      return false;
    }, // v-modelで直接指定する代わりに、双方向算出プロパティを定義する
    ...mapGetters([
      'game',
      'user',
      'app',
    ]),
  },
  methods: {
    ...mapActions([
      'addPoint',
      'delPoint',
      'addGameInfo',
      'addManualLabel',
      'delManualLabel',
      'addManualArray',
      'popManualArray',
      'reset',
      'SignOut',
      'delGameData',
      'linkShareFlgOn',
      'publicShareFlgOn',
      'storeIsLoading',
    ]),
    submitData(isToDataPage) {
      // gameInfoの設定
      this.addGameInfo({ key: 'player1Game', value: this.info.s1 });
      this.addGameInfo({ key: 'player2Game', value: this.info.s2 });
      const db = firebase.firestore();
      if (this.user.signIn && this.app.docId !== undefined) {
        if (isToDataPage) {
          this.storeIsLoading(true);
        }
        db.collection('games').doc(this.app.docId).update({
          points: this.game.points,
          labels: this.game.labels,
          manualLabels: this.game.manualLabels,
          gameInfo: this.game.gameInfo,
          status: this.game.status,
          updateDate: firebase.firestore.FieldValue.serverTimestamp(),
        })
          .then(() => {
            if (isToDataPage) {
              this.reset({ isProMode: false });
              this.$router.push('/data_page');
            }
          })
          .catch((error) => {
            if (error.code === 'permission-denied') {
              alert('タイムアウトしました。再度ログインしてからやり直してください。');
              this.SignOut();
              this.$router.push('/');
            } else {
              alert('データの保存に失敗しました。しばらくしてから再度やり直してください。');
            }
          })
          .finally(() => {
            this.storeIsLoading(false);
          });
      } else if (this.user.signIn) {
        if (isToDataPage) {
          this.storeIsLoading(true);
        }
        // 二重保存防止
        this.submittingFlg = true;
        db.collection('games').add({
          author: this.user.uid,
          points: this.game.points,
          labels: this.game.labels,
          manualLabels: this.game.manualLabels,
          gameInfo: this.game.gameInfo,
          status: this.game.status,
          createDate: firebase.firestore.FieldValue.serverTimestamp(),
          updateDate: firebase.firestore.FieldValue.serverTimestamp(),
        })
          .then(() => {
            this.submittingFlg = false;
            this.reset({ isProMode: false });
            this.$router.push('/data_page');
          })
          .catch((error) => {
            this.submittingFlg = false;
            if (error.code === 'permission-denied') {
              alert('タイムアウトしました。再度ログインしてからやり直してください。');
              this.SignOut();
              this.$router.push('/');
            } else {
              alert('データの保存に失敗しました。しばらくしてから再度やり直してください。');
            }
          })
          .finally(() => {
            this.storeIsLoading(false);
          });
      } else {
        alert('ログイン後ご利用ください。');
      }
    },
    outputData() {
      alert('PC版ChromeまたはMicrosoft Edgeをお使いください。その他のブラウザでは動作しません。');
      makeCsv.exportCsv(this.game);
    },
    deleteData() {
      if (confirm('データを削除します。よろしいですか？')) {
        this.delGameData();
        this.submitData(true);
        this.reset({ isProMode: false });
      }
    },
    resetConf(isProMode) {
      if (confirm('分析中のデータをリセットしますか？ (保存済みのデータは削除されません) ')) {
        this.reset({ isProMode });
      }
    },
    linkShareFlgOnClick() {
      // v-modelでの値の変更よりクリックイベントほうが先に動くらしいので、反転させる
      if (!this.game.gameInfo.publicShareFlg) {
        this.linkShareFlgOn(true);
      }
    },
    publicShareFlgOnClick() {
      if (this.game.gameInfo.linkShareFlg) {
        this.publicShareFlgOn(false);
      }
    },
  },
};
</script>

<style scoped>
#analyze{
  text-align: center;
}

.btn-dblue{
  color: #fff;
  background-color: #66a2cc;
  border-color: #66a2cc;
  width: 100%;
  height: 60px;
}

.btn-dgreen{
  color: #fff;
  background-color: #04B4AE;
  border-color: #04B4AE;
  width: 100%;
  height: 60px;
}

.btn-option{
  width: 100%;
  height: 60px;
}

.pa-2 {
  padding: 2px;
}

.mw-600{
  max-width: 600px;
}

.btn-middle {
  background-color: #387CA6;
  border-color: #387CA6;
}

.title-font{
  font-family: 'Orbitron', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/AnalyzeNormal.vue